import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_ValidationAlert = _resolveComponent("ValidationAlert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_ctx.accessRequestExists && !_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        fluid: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            class: "text-left",
            tag: "v-card-text"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("h4", null, "Your access request has been submitted and is currently under review. We appreciate your patience!", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (!_ctx.accessRequestExists && !_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_v_container, {
          key: 1,
          fluid: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ValidationAlert, { "validation-results": _ctx.validationResults }, null, 8, ["validation-results"]),
            _createVNode(_component_v_row, {
              class: "text-left",
              tag: "v-card-text"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("h4", null, "It looks like it's your first time using the CST system. Please complete the form below to request access.", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_form, {
              modelValue: _ctx.isFormValid,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isFormValid) = $event)),
              onSubmit: _withModifiers(_ctx.submitAccessRequest, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  class: "text-left",
                  tag: "v-card-text"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.accessRequestObject.firstName,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accessRequestObject.firstName) = $event)),
                          label: "First Name",
                          maxlength: "50",
                          counter: "",
                          rules: _ctx.requiredFieldRules
                        }, null, 8, ["modelValue", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.accessRequestObject.lastName,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.accessRequestObject.lastName) = $event)),
                          label: "Last Name",
                          maxlength: "50",
                          counter: "",
                          rules: _ctx.requiredFieldRules
                        }, null, 8, ["modelValue", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.accessRequestObject.userName,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.accessRequestObject.userName) = $event)),
                          label: "Username",
                          maxlength: "50",
                          counter: "",
                          rules: _ctx.requiredFieldRules
                        }, null, 8, ["modelValue", "rules"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  class: "text-left",
                  tag: "v-card-text"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.accessRequestObject.email,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.accessRequestObject.email) = $event)),
                          label: "Email",
                          rules: _ctx.requiredFieldRules,
                          disabled: true
                        }, null, 8, ["modelValue", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.accessRequestObject.phone,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.accessRequestObject.phone) = $event)),
                          label: "Phone",
                          maxlength: "12",
                          counter: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  class: "text-left",
                  tag: "v-card-text"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.selectedRoleIds,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedRoleIds) = $event)),
                          items: _ctx.selectableRoles,
                          "item-value": "roleId",
                          "item-title": "description",
                          label: "Select Desired Roles",
                          multiple: "",
                          hint: "Pick the roles you will need to operate within CST",
                          clearable: true,
                          rules: _ctx.atLeastOneRules
                        }, null, 8, ["modelValue", "items", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.selectedCountyIds,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCountyIds) = $event)),
                          items: _ctx.selectableCounties,
                          "item-value": "countyId",
                          "item-title": "description",
                          label: "Select Desired Counties",
                          multiple: "",
                          hint: "Pick the county or counties you are assigned to",
                          clearable: true,
                          rules: _ctx.atLeastOneRules
                        }, null, 8, ["modelValue", "items", "rules"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  class: "text-left",
                  tag: "v-card-text"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.selectedCourtIds,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedCourtIds) = $event)),
                          items: _ctx.selectableCourts,
                          "item-value": "courtId",
                          "item-title": "description",
                          label: "Select Desired Courts",
                          multiple: "",
                          hint: "Pick the court or courts you are working with",
                          clearable: true,
                          disabled: _ctx.courtSelectDisabled,
                          rules: _ctx.atLeastOneRules
                        }, null, 8, ["modelValue", "items", "disabled", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.selectedTreatmentProgramIds,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedTreatmentProgramIds) = $event)),
                          items: _ctx.selectableTreatmentPrograms,
                          "item-value": "treatmentProgramId",
                          "item-title": "description",
                          label: "Select Desired Programs",
                          multiple: "",
                          hint: "Pick the treatment program or programs you are working on",
                          clearable: true,
                          disabled: _ctx.programSelectDisabled,
                          rules: _ctx.atLeastOneRules
                        }, null, 8, ["modelValue", "items", "disabled", "rules"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, {
                  class: "text-left",
                  tag: "v-card-text"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                          type: "submit",
                          class: "white--text",
                          color: "success",
                          depressed: ""
                        }, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createTextVNode("Save", -1)
                          ]))]),
                          _: 1
                        })), [
                          [_directive_ripple]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "onSubmit"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
}